import { Button, Modal, Typography } from "@joonapp/web-shared"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { create } from "zustand"

import ThoughtfulModal, { useThoughtfulModalStore } from "./ThoughtfulModal"
import { createReferralGiftCard } from "../../../networking/users/api"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../util/analytics"
import { localStorageItems } from "../../../util/storage"
import { shareGuestPass } from "../../../util/util"

interface ReferralFTUXModalStoreProps {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useReferralFTUXModalStore = create<ReferralFTUXModalStoreProps>(
  (set) => ({
    isOpen: false,
    onOpen: () => {
      trackAnalyticEvent(ANALYTIC_EVENTS.OPEN_REFERRAL_FTUX)
      set({ isOpen: true })
    },
    onClose: () => {
      localStorage.setItem(localStorageItems.hasSeenReferralFTUXModal, "true")
      set({ isOpen: false })
    },
  })
)

const ReferralFTUXModal = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { isOpen, onClose } = useReferralFTUXModalStore()
  const { onOpen: onOpenThoughtfulModal } = useThoughtfulModalStore()
  const { t } = useTranslation()

  const onShareGuestPass = async () => {
    setIsLoading(true)
    const referralGiftCard = await createReferralGiftCard()
    setIsLoading(false)
    if (!referralGiftCard || !referralGiftCard.uuid) return
    await shareGuestPass(referralGiftCard, onOpenThoughtfulModal)
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} animate displayCloseIcon>
      <div
        className="flex flex-col gap-4 py-6"
        style={{
          width: "min(450px, 100vw)",
        }}
      >
        <Typography variant="h3" textAlign="left" className="px-6">
          {t("REFERRAL_FTUX_TITLE")}
        </Typography>

        <img
          src={"/images/referral_gift_card_yellow_sparkles.png"}
          alt="Referral FTUX"
        />
        <div className="flex flex-col gap-4 px-6 items-center">
          <Typography variant="bodySmall">{t("REFERRAL_FTUX_DESC")}</Typography>
          <Button
            text={t("REFERRAL_MODAL_SHARE")}
            onClick={onShareGuestPass}
            fullWidth
            isLoading={isLoading}
          />
        </div>
      </div>
      <ThoughtfulModal onShareGuestPass={onShareGuestPass} />
    </Modal>
  )
}

export default ReferralFTUXModal
